import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Header } from './header/header';
import { Sidenav } from './sidenav/sidenav';

@Component({
  selector: 'app-layout',
  imports: [CommonModule, Header, Sidenav],
  templateUrl: './layout.html',
  styleUrl: './layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Layout {
  // Sidebar collapsed state management
  isSidebarCollapsed = signal(false);

  // Computed classes for main content area
  mainContentClass = computed(() => ({
    'main-content': true,
    'main-content--collapsed': this.isSidebarCollapsed(),
  }));

  // Handle sidebar collapsed state change
  onSidebarCollapsedChange(collapsed: boolean): void {
    this.isSidebarCollapsed.set(collapsed);
  }
}
